// Linked profiles' Relationship / Role box (QA batch 12, 2026-10-21): max 100
// characters (it had no limit). The backend refuses longer text too.
export const RELATIONSHIP_MAX = 100;
export const RELATIONSHIP_TOO_LONG = `Relationship can be at most ${RELATIONSHIP_MAX} characters.`;

export const relationshipProblem = (value?: string | null): string =>
  (value || "").trim().length > RELATIONSHIP_MAX ? RELATIONSHIP_TOO_LONG : "";
